module.exports = __webpack_public_path__ + "static/media/icon.e50c3f63.png";